module.exports = __webpack_public_path__ + "975e105cee616cde0829e14f67e758c4.svg";